import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { cleanedString } from '../../../Helper/Calculation';
import report_img from '../../../Images/Logo/report-anim.gif'

const Quizanswer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [quizData, setQuizData] = useState({
    answer: [],
    head: '',
    question: [],
  });
  const [index, setIndex] = useState(0);
  const [showReportModal, setShowReportModal] = useState(false);

  // useEffect(() => {
  //   let data = location.state;
  //   if (!data) {
  //     const saved = sessionStorage.getItem("quizScoreData");
  //     if (saved) {
  //       data = JSON.parse(saved);
  //     } else {
  //       navigate("/", { replace: true });
  //       return;
  //     }
  //   }
  //   setQuizData({
  //     answer: data.answer,
  //     head: data.head,
  //     question: data.question,
  //   });
  // }, [location.state, navigate]);

  useEffect(() => {
    const data = location.state;

    if (!data) {
      navigate("/", { replace: true });
      return;
    }

    setQuizData({
      answer: data.answer,
      head: data.head,
      question: typeof data.question === "string" ? JSON.parse(data.question) : data.question,
    });
  }, [location.state, navigate]);



  // useEffect(() => {
  //   window.history.pushState(null, "", window.location.href);
  //   const handlePopState = () => {
  //     navigate("/", { replace: true });
  //   };
  //   window.addEventListener("popstate", handlePopState);
  //   return () => {
  //     window.removeEventListener("popstate", handlePopState);
  //   };
  // }, [navigate]);

  const { answer, head, question } = quizData;

  if (!question || question.length === 0) {
    return <p>Loading...</p>;
  }

  const quiz = question[index];
  const totalQuestions = question.length;

  const next = () => {
    if (index < totalQuestions - 1) setIndex(index + 1);
  };

  const previous = () => {
    if (index > 0) setIndex(index - 1);
  };

  const correctAnswer = cleanedString(quiz.answer);
  const userAnswer = cleanedString(answer[index] || '');

  const getOptionClass = (option) => {
    if (option === correctAnswer) return 'option correct';
    if (option === userAnswer && option !== correctAnswer) return 'option wrong';
    return 'option';
  };

  return (
    <div className='quiz-container'>
      <div className='headers'>
        <h2>Topic: {head}</h2>
      </div>

      <div className='question-box-wrapper'>
        <div className='question-box'>
          <h3>{index + 1}. {cleanedString(quiz.question)}</h3>
          <div className='question-body' dangerouslySetInnerHTML={{ __html: quiz.question_body }} />

          <div className='options'>
            {[quiz.option1, quiz.option2, quiz.option3, quiz.option4].map((opt, i) => {
              const option = cleanedString(opt);
              return (
                <label key={i} className={getOptionClass(option)}>
                  <input
                    type='radio'
                    name={`question-${index}`}
                    checked={option === userAnswer}
                    readOnly
                  />
                  {option}
                </label>
              );
            })}
          </div>

          <div className='answer-report'>
            {userAnswer ? (
              userAnswer === correctAnswer ? (
                <p className='correct-text'>✅ Correct</p>
              ) : (
                <p>
                  <span className='wrong-text'>❌ Wrong</span><br />
                  <span className='correct-text'>Correct Answer: {correctAnswer}</span>
                </p>
              )
            ) : (
              <p className='wrong-text'>❗ Not Attempted</p>
            )}
          </div>
          {quiz.solution && quiz.solution.trim() !== "" && (
            <div className='question-sollution'>
              <p>Solution :</p>
              <div
                className="question-body"
                dangerouslySetInnerHTML={{ __html: quiz.solution }}
              />
            </div>
          )}

        </div>

        <div className='navigation'>
          {index > 0 ? (
            <button className='review-btn' onClick={previous}>Previous</button>
          ) : <div />}
          <button className="report-btn" onClick={() => setShowReportModal(true)}>
            Report this question
          </button>
          {index < totalQuestions - 1 ? (
            <button className='next-btn' onClick={next}>Next</button>
          ) : <div />}
        </div>
      </div>

      {/* Report Modal */}
      {showReportModal && (
        <div className="report-overlay">
          <div className="report-content">
            <img src={report_img} alt="report" className="report-icon" />
            <h3>Report this Question ?</h3>
            <p>If you have any doubt or want to rectify this question, please feel free to report.</p>
            <div className="report-actions">
              <button className="report-btn" onClick={() => setShowReportModal(false)}>Close</button>
              <button className="report-btn report" onClick={() => {
                let msg = cleanedString(quiz.question)
                window.open(`https://wa.me/917001739646?text=${msg}`, "_blank");
                setShowReportModal(false);
              }}>
                Report Now!
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Quizanswer;
